<template>
  <div>
    <div :class="['app-screen-popup', 'horizontal']">
      <div class="app-screen-inner">
        <i :class="['app-screen-icon']"></i>
        <span class="app-screen-text">Please rotate your phone for the best browsing experience</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ScreenTip'
}
</script>

<style lang="scss" scoped>
.app-screen-popup {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  color: #e3e3e3;
  text-align: center;
  background-color: #2e215a;
  &.horizontal {
    .app-screen-icon {
      width: 30vw;
      height: 18vw;
      animation: swingTwo 1.5s ease infinite alternate;
    }
    .app-screen-text {
      margin-top: 2.2rem;
      font-size: 1rem;
    }
  }
}
.app-screen-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5%;
}
.app-screen-icon {
  margin: auto;
  background: url('https://cdn.cr.dhgamesdownload.com/common/web_event/cr-official/20266/eae64f97c4ea9f0ad4437889e192f26d.png')
    center / contain no-repeat;
}

@media screen and (orientation: landscape) and (max-width: 1023px) {
  body:not(.use-p) {
    .app-screen-popup.horizontal {
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}

@keyframes swingTwo {
  0% {
    transform: rotate(0deg);
  }

  30% {
    transform: rotate(0deg);
  }

  70% {
    transform: rotate(-90deg);
  }

  100% {
    transform: rotate(-90deg);
  }
}
</style>
